import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { hasProperty } from "helpers/object";
import ChangeClient from "components/Common/ChangeClient";
import Translate from "helpers/Translate";

function ClientInfo() {
  const [showModal, setShowModal] = useState(false);
  const client = useSelector(state => state.client.selectedClient);

  // Show client selection modal if the client isnt set
  useEffect(() => {
    if (!client) {
      setShowModal(true);
    }
  }, [client]);

  const toggleHandleChange = e => {
    if (e) {
      e.preventDefault();
    }
    setShowModal(!showModal);
  };

  return (
    <>
      <div className="client-container">
        <h1 className="client fl">
          {hasProperty(
            () => client.name,
            Translate({ id: "no_client_selected" })
          )}
        </h1>
        <a href="/" className="change fr" onClick={toggleHandleChange}>
          [{Translate({ id: "change" })} ]
        </a>
        <h1 className="collection mt-40">
          {hasProperty(
            () => client.department_item_value.toUpperCase(),
            Translate({ id: "no_collection_selected" })
          )}
        </h1>
        <hr className="my-30" />
        <h1 className="client-info mb-20">
          {Translate({ id: "client_information" })} :
        </h1>
        <ul className="client-info-data">
          <li>
            <strong>{Translate({ id: "total_characters" })} : </strong>
            <span>{hasProperty(() => client.characters_entered, 0)}</span>
          </li>
        </ul>
      </div>
      <ChangeClient
        toggleHandleChange={toggleHandleChange}
        visible={showModal}
      />
    </>
  );
}

export default ClientInfo;
